var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorPicker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.005 18.334v5.335a5.336 5.336 0 01-5.336 5.336H10.331a5.336 5.336 0 01-5.336-5.336V10.331a5.336 5.336 0 015.336-5.336h5.335M26.337 12.998l-5.335-5.335",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.734 11.664l5.877-5.869v0a2.544 2.544 0 013.602 0v0a2.545 2.545 0 010 3.602l-5.877 5.869C20.299 17.292 18.007 16 17 17c.998-1.003-.295-3.292 1.734-5.336z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.997 17h2M12.517 13.005l-1.414-1.42M22.397 22.916l-1.414-1.42M11.103 22.414l1.414-1.419M16.5 25.003v-2.007",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgColorPicker;